export default __webpack_public_path__ + "static/media/safari.dde446e2.svg";